import { useState } from 'react'
import { useQuery } from '@apollo/client'
import Cookies from 'universal-cookie'
import classNames from 'classnames'

import Button from 'components/Button'
import ButtonLink from 'components/ButtonLink'

import GET_AVAILABLE_PROMOTIONS_BANNER_DATA from './graphql/GetAvailablePromotionsBannerData.graphql'
import { GetAvailablePromotionsBannerData } from './graphql/__generated__/GetAvailablePromotionsBannerData'

import styles from './AvailablePromotionsBanner.module.css'
import {
  CatalogMarketplaceApprovalStatusEnum,
  SellerMarketplaceApprovalStatusEnum
} from '../../../../../../__generated__/globalTypes'
const cx = classNames.bind(styles)

type AvailablePromotionsBannerProps = {
  className?: string
}

export const PROMO_BANNER_COOKIE = 'promotions_banner_sept2025_dismissed'

const AvailablePromotionsBanner = ({ className }: AvailablePromotionsBannerProps) => {
  const cookies = new Cookies()
  const isBannerDismissed = (cookies.get(PROMO_BANNER_COOKIE) ?? 'false') == 'true' ? true : false
  const [bannerDismissed, setBannerDismissed] = useState<boolean>(isBannerDismissed)

  const { data } = useQuery<GetAvailablePromotionsBannerData>(GET_AVAILABLE_PROMOTIONS_BANNER_DATA, {
    skip: isBannerDismissed
  })

  const isSellerApproved =
    data?.currentSeller.marketplaceApprovalStatus === SellerMarketplaceApprovalStatusEnum.APPROVED
  const hasApprovedCatalogs = data?.currentSeller.catalogs.nodes.some(
    catalog => catalog.marketplaceApprovalStatus === CatalogMarketplaceApprovalStatusEnum.APPROVED
  )

  const handleDismissBanner = () => {
    cookies.set(PROMO_BANNER_COOKIE, 'true')
    setBannerDismissed(true)
  }

  if (!isSellerApproved || !hasApprovedCatalogs || bannerDismissed) return null

  return (
    <div className={styles.container}>
      <div className={cx(styles.bannerContainer, className)}>
        <div className={styles.innerContainer}>
          <img src="/seller-hub/promotions/available-promo-image.svg" alt="available-promo" />

          <div className={styles.content}>
            <p className={styles.title}>Spring Promotional Spots Available Through Mid-September</p>

            <p className={styles.text}>Premium spots available for the Spring and early Christmas buying.</p>

            <ButtonLink
              kind="primary"
              href="/sh/promotions"
              label="Book Your Promotion"
              icon="arrow-right"
              iconPosition="right"
            />
          </div>
        </div>

        <div className={styles.dismissContainer}>
          <Button
            kind="link"
            size="default"
            icon="x"
            iconPosition="right"
            className={cx(styles.dismissButton, styles.transparentLink)}
            onClick={handleDismissBanner}
          />
        </div>
      </div>
    </div>
  )
}

export default AvailablePromotionsBanner
